import(/* webpackMode: "eager" */ "/home/interim/frontend/app/safety/page.tsx");
